export default __webpack_public_path__ + "static/calipers-11944bc14942166f6026f51fd738f7f2.png";